import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { Behavior } from '@prisjakt/ui/text';
import { TitleSmallText } from '@prisjakt/ui/text/variants';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { getSizeTitle } from './utils';
import { getSelectionsString } from '../utils/selections';
import { FilterType } from 'src/components/price-list/types';
import { DropdownButtonText, SelectionHighlightedText } from '../styles-common';

export const SizeVariantsButtonLabel = () => {
  const { t } = useAppContext();
  const { getFilter } = useOfferListFilterContext();
  const title = getSizeTitle(t);
  const filter = getFilter(FilterType.VARIANT_SIZE);
  const selectedVariants =
    getSelectionsString(t, filter) ?? t('product', 'variants.all');

  return (
    <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
      <TitleSmallText>
        {title}:{' '}
        <SelectionHighlightedText>{selectedVariants}</SelectionHighlightedText>
      </TitleSmallText>
    </DropdownButtonText>
  );
};
